"use client";

import { useState, useEffect } from "react";
import "../css/sellermanagement.css";
import {
  getWithTokenAPI,
  putAPI,
  postWithTokenAPI,
  postWithoutTokenAPI,
} from "../../utils/Api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  CircularProgress,
  Box,
  Typography,
  Button,
  Switch,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  InputLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Pagination,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  Edit as EditIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import { useTheme } from "@mui/material/styles";

function SellerManagement() {
  const [sellerList, setSellerList] = useState([]);
  const [filteredSellers, setFilteredSellers] = useState([]);
  const [activeTab, setActiveTab] = useState("active");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showAddSellerModal, setShowAddSellerModal] = useState(false);
  const [currentSeller, setCurrentSeller] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false); // New state for modal loading
  const [approvalStatus, setApprovalStatus] = useState("Pending");
  const permissions = JSON.stringify(localStorage.getItem("permissions"))
  const [newSellerData, setNewSellerData] = useState({
    name: "",
    email: "",
    phone_number: "",
    password: "",
    role: "seller",
  });
  const [newSellerErrors, setNewSellerErrors] = useState({});
  const [approvalFormData, setApprovalFormData] = useState({
    servingLocation: "",
    idProofFile: null,
    deliveryMethod: "",
    idProofUrl: "",
  });
  const [approvalErrors, setApprovalErrors] = useState({});
  const [isIdProofUploading, setIsIdProofUploading] = useState(false);
  const [idProofError, setIdProofError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const navigate = useNavigate();
  const primaryGreen = "#DC3545";
  const lightGreen = "#ffe5e5";

  const [showIdProofViewer, setShowIdProofViewer] = useState(false);
  const [idProofToViewUrl, setIdProofToViewUrl] = useState("");

  const theme = useTheme();
  const secondaryTextColor = theme.palette.text.secondary;

  const fetchSellers = async (filterType = null, filterValue = null) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      let url = "/seller/find-all";
      const queryParams = [];
      if (filterType && filterValue) {
        queryParams.push(`${filterType}=${filterValue}`);
      }
      if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
      }
      const res = await getWithTokenAPI(token, url);
      const users = res?.data?.User || [];
      setSellerList(users);
      setFilteredSellers(users);
      setCurrentPage(1); // Reset to first page on new filter/fetch
    } catch (error) {
      toast.error("Failed to fetch sellers");
      console.error("Fetch error:", error);
      setSellerList([]);
      setFilteredSellers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = async (tabId) => {
    setActiveTab(tabId);
    let filterType = null;
    let filterValue = null;
    switch (tabId) {
      case "active":
        filterType = "status";
        filterValue = "Active";
        break;
      case "inactive":
        filterType = "status";
        filterValue = "Inactive";
        break;
      case "Pending":
        filterType = "Approval_status";
        filterValue = "Pending";
        break;
      case "Approved": // Changed from "Approval" to "Approved"
        filterType = "Approval_status";
        filterValue = "Approval"; // Changed from "Approval" to "Approved"
        break;
      case "Reject":
        filterType = "Approval_status";
        filterValue = "Reject";
        break;
      default:
        break;
    }
    await fetchSellers(filterType, filterValue);
  };

  useEffect(() => {
    handleTabChange("active");
  }, []);

  const handleStatusToggle = async (sellerId, currentStatus) => {
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const res = await putAPI(token, `/seller/update`, {
        _id: sellerId,
        status: newStatus,
      });
      console.log("sellerupdate---------------", res)
      if (res.statusCode !== 200) {
        throw new Error(res.message || "Failed to update status");
      }
      toast.success("Status updated successfully", {
        autoClose: 1500,
        onClose: () => handleTabChange(activeTab),
      });
    } catch (error) {
      console.error("Toggle status error:", error);
      toast.error(error.message || "Failed to update status");
    } finally {
      setLoading(false);
    }
  };

  // const handleEdit = async (seller) => {
  //   setCurrentSeller(seller);
  //   setApprovalStatus(seller.Approval_status || "Pending");
  //   setApprovalErrors({});
  //   setIdProofError("");
  //   setIsModalOpen(true);
  //   setIsModalLoading(true); 

  //   try {
  //     const token = localStorage.getItem("token");
  //     if (!token) {
  //       toast.error("Authentication token not found. Please log in.");
  //       navigate("/login");
  //       setIsModalLoading(false);
  //       return;
  //     }

  //     // Fetch detailed seller data using the /user/find-particular API
  //     const detailedSellerRes = await getWithTokenAPI(
  //       token,
  //       `/user/find-particular?_id=${seller._id}`
  //     );

  //     if (detailedSellerRes.statusCode === 200 && detailedSellerRes.data) {
  //       const detailedSellerData = detailedSellerRes.data;
  //       console.log(
  //         "Detailed seller data fetched for modal:",
  //         detailedSellerData
  //       ); 

  //       setApprovalFormData({
  //         servingLocation:
  //           detailedSellerData.seller_profile?.serving_location?.join(", ") ||
  //           "",
  //         idProofFile: null, 
  //         deliveryMethod:
  //           detailedSellerData.seller_profile?.delivery_method || "",
  //         idProofUrl: detailedSellerData.seller_profile?.govt_id_proof || "",
  //       });
  //       setCurrentSeller(detailedSellerData);
  //     } else {
  //       toast.error(
  //         detailedSellerRes.message ||
  //         "Failed to fetch detailed seller data for edit."
  //       );
  //       setApprovalFormData({
  //         servingLocation: "",
  //         idProofFile: null,
  //         deliveryMethod: "",
  //         idProofUrl: "",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching detailed seller data for modal:", error);
  //     toast.error("An error occurred while fetching seller details for edit.");
  //     setApprovalFormData({
  //       servingLocation: "",
  //       idProofFile: null,
  //       deliveryMethod: "",
  //       idProofUrl: "",
  //     });
  //   } finally {
  //     setIsModalLoading(false); 
  //   }
  // };

  const handleEdit = async (seller) => {
    setCurrentSeller(seller);
    setApprovalStatus(seller.Approval_status || "Pending");
    setApprovalErrors({});
    setIdProofError("");
    setIsModalOpen(true);
    setIsModalLoading(true);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token not found. Please log in.");
        navigate("/login");
        setIsModalLoading(false);
        return;
      }

      // Fetch detailed seller data
      const detailedSellerRes = await getWithTokenAPI(
        token,
        `/user/find-particular?_id=${seller._id}`
      );

      if (detailedSellerRes.statusCode === 200 && detailedSellerRes.data) {
        const detailedSellerData = detailedSellerRes.data;
        const sellerProfile = detailedSellerData.seller_profile || {};

        console.log("Fetched seller profile data:", sellerProfile); // Debug log

        // Check if seller_profile exists and has the required fields
        const servingLocations = sellerProfile.serving_location || [];
        const deliveryMethod = sellerProfile.delivery_method || "";
        const govtIdProof = sellerProfile.govt_id_proof || "";

        setApprovalFormData({
          servingLocation: servingLocations.join(", "),
          idProofFile: null,
          deliveryMethod: deliveryMethod,
          idProofUrl: govtIdProof,
        });

        setCurrentSeller(detailedSellerData);
      } else {
        toast.error(
          detailedSellerRes.message ||
          "Failed to fetch detailed seller data for edit."
        );
        setApprovalFormData({
          servingLocation: "",
          idProofFile: null,
          deliveryMethod: "",
          idProofUrl: "",
        });
      }
    } catch (error) {
      console.error("Error fetching detailed seller data for modal:", error);
      toast.error("An error occurred while fetching seller details for edit.");
      setApprovalFormData({
        servingLocation: "",
        idProofFile: null,
        deliveryMethod: "",
        idProofUrl: "",
      });
    } finally {
      setIsModalLoading(false);
    }
  };
  const handleIdProofUpload = async (e) => {
    setIdProofError("");
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    const file = files[0];
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "application/pdf",
    ];
    const maxSize = 5 * 1024 * 1024;
    if (!allowedTypes.includes(file.type)) {
      setIdProofError("Only JPEG, PNG, GIF, or PDF files are allowed.");
      e.target.value = null;
      return;
    }
    if (file.size > maxSize) {
      setIdProofError("File size cannot exceed 5MB.");
      e.target.value = null;
      return;
    }
    setIsIdProofUploading(true);
    const formData = new FormData();
    formData.append("files", file);
    formData.append("path", `media/seller_id_proofs/${currentSeller._id}/`);
    try {
      const response = await postWithoutTokenAPI("/files/upload", formData);
      if (response.error) {
        throw new Error(response.error);
      }
      const uploadedUrl = response.data[0]?.file_url;
      if (uploadedUrl) {
        setApprovalFormData((prevData) => ({
          ...prevData,
          idProofUrl: uploadedUrl,
          idProofFile: null,
        }));
        toast.success("ID Proof uploaded successfully!");
      } else {
        throw new Error("No file URL returned from ID proof upload.");
      }
    } catch (error) {
      console.error("Error uploading ID proof:", error);
      toast.error("Failed to upload ID proof. Please try again.");
      setApprovalFormData((prevData) => ({
        ...prevData,
        idProofFile: null,
      }));
      setIdProofError(error.message || "Failed to upload ID proof.");
    } finally {
      setIsIdProofUploading(false);
      e.target.value = null;
    }
  };

  const handleApprovalInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "idProofFile" && files && files.length > 0) {
      handleIdProofUpload(e); // Directly call upload function here
    } else {
      setApprovalFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
      setApprovalErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  const validateApprovalForm = () => {
    const tempErrors = {};
    let isValid = true;
    if (!approvalFormData.servingLocation.trim()) {
      tempErrors.servingLocation = "Serving Location is required.";
      isValid = false;
    }
    if (!approvalFormData.deliveryMethod) {
      tempErrors.deliveryMethod = "Delivery Method is required.";
      isValid = false;
    }
    if (approvalStatus === "Approval" && !approvalFormData.idProofUrl) {
      // Changed "Approval" to "Approved"
      tempErrors.idProofFile = "ID Proof must be uploaded before approval.";
      isValid = false;
    }
    setApprovalErrors(tempErrors);
    return isValid;
  };

  // const handleUpdateApproval = async () => {
  //   if (!currentSeller) return;
  //   if (!validateApprovalForm()) {
  //     toast.error(
  //       "Please fill all required fields and ensure ID proof is uploaded if approving."
  //     );
  //     return;
  //   }
  //   const token = localStorage.getItem("token");
  //   const payload = {
  //     _id: currentSeller._id,
  //     Approval_status: approvalStatus,
  //     seller_profile: {
  //       // Wrap serving_location, delivery_method, govt_id_proof under seller_profile
  //       serving_location: approvalFormData.servingLocation
  //         .split(",")
  //         .map((s) => s.trim())
  //         .filter(Boolean),
  //       delivery_method: approvalFormData.deliveryMethod,
  //       govt_id_proof: approvalFormData.idProofUrl,
  //     },
  //   };
  //   try {
  //     setLoading(true);
  //     const res = await putAPI(token, "/seller/update", payload);
  //     console.log("Update approval response:", res);
  //     if (res.statusCode !== 200) {
  //       throw new Error(
  //         res.message || "Failed to update approval status or seller details"
  //       );
  //     }
  //     toast.success("Approval status and seller details updated successfully", {
  //       autoClose: 1500,
  //       onClose: () => {
  //         setIsModalOpen(false);
  //         handleTabChange(activeTab);
  //       },
  //     });
  //   } catch (error) {
  //     console.error("Update approval error:", error);
  //     toast.error(
  //       error.message || "Failed to update approval status or seller details"
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleUpdateApproval = async () => {
    if (!currentSeller) return;
    if (!validateApprovalForm()) {
      toast.error(
        "Please fill all required fields and ensure ID proof is uploaded if approving."
      );
      return;
    }

    const token = localStorage.getItem("token");
    const payload = {
      _id: currentSeller._id,
      Approval_status: approvalStatus,
      serving_location: approvalFormData.servingLocation,
      delivery_method: approvalFormData.deliveryMethod,
      govt_id_proof: approvalFormData.idProofUrl

    };

    try {
      setLoading(true);
      const res = await putAPI(token, "/seller/update", payload);
      console.log("Update approval response:", res);
      if (res.statusCode !== 200) {
        throw new Error(
          res.message || "Failed to update approval status or seller details"
        );
      }
      toast.success("Approval status and seller details updated successfully", {
        autoClose: 1500,
        onClose: () => {
          setIsModalOpen(false);
          handleTabChange(activeTab);
        },
      });
    } catch (error) {
      console.error("Update approval error:", error);
      toast.error(
        error.message || "Failed to update approval status or seller details"
      );
    } finally {
      setLoading(false);
    }
  };


  const handleNewSellerInputChange = (e) => {
    const { name, value } = e.target;
    setNewSellerData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setNewSellerErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validateNewSellerForm = () => {
    const tempErrors = {};
    let isValid = true;
    if (!newSellerData.name.trim()) {
      tempErrors.name = "Seller Name is required.";
      isValid = false;
    }
    if (!newSellerData.email.trim()) {
      tempErrors.email = "Email is required.";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(newSellerData.email)) {
      tempErrors.email = "Email is not valid.";
      isValid = false;
    }
    if (!newSellerData.phone_number.trim()) {
      tempErrors.phone_number = "Phone Number is required.";
      isValid = false;
    }
    if (!newSellerData.password.trim()) {
      tempErrors.password = "Password is required.";
      isValid = false;
    } else if (newSellerData.password.length < 6) {
      tempErrors.password = "Password must be at least 6 characters.";
      isValid = false;
    }
    setNewSellerErrors(tempErrors);
    return isValid;
  };

  const handleAddSeller = async () => {
    if (!validateNewSellerForm()) {
      toast.error("Please correct the errors in the form.");
      return;
    }
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const res = await postWithTokenAPI(
        token,
        "/seller/create",
        newSellerData
      );
      console.log("Add Seller response:", res);
      if (res.statusCode === 200) {
        toast.success("Seller added successfully!", {
          autoClose: 1500,
          onClose: () => {
            setShowAddSellerModal(false);
            setNewSellerData({
              name: "",
              email: "",
              phone_number: "",
              password: "",
              role: "seller",
            });
            setNewSellerErrors({});
            handleTabChange(activeTab);
          },
        });
      } else {
        throw new Error(res.message || "Failed to add seller.");
      }
    } catch (error) {
      console.error("Add Seller error:", error);
      toast.error(error.message || "Failed to add seller.");
    } finally {
      setLoading(false);
    }
  };


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSellers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredSellers.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };


  const isImageUrl = (url) => {
    return /\.(jpeg|jpg|png|gif)$/i.test(url);
  };

  return (
    <Box sx={{ p: { xs: 1, md: 3 }, width: "100%", overflowX: "hidden" }}>
      <ToastContainer position="top-center" autoClose={1500} />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 3,
          p: 2,
          backgroundColor: lightGreen,
          borderRadius: 2,
          borderLeft: `5px solid ${primaryGreen}`,
        }}
      >
        <PersonIcon sx={{ color: primaryGreen, fontSize: 50, mr: 2 }} />
        <Box>
          <Typography
            variant="h4"
            component="h1"
            sx={{ color: primaryGreen, fontWeight: "bold" }}
          >
            Seller
          </Typography>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            Manage Sellers
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          width: "100%",
          flexDirection: { xs: "column", md: "row" }, // Stack on small screens
          gap: { xs: 2, md: 0 },
        }}
      >
        <Box
          sx={{
            backgroundColor: lightGreen,
            p: 0.5,
            borderRadius: 2,
            display: "inline-flex",
            flexWrap: "wrap",
            justifyContent: { xs: "center", md: "flex-start" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              borderBottom: "none",
              flexWrap: "wrap",
              justifyContent: "center",
              "& button": {
                backgroundColor: "white",
                color: primaryGreen,
                border: "1px solid white",
                mb: { xs: 1, md: 0 },
                fontWeight: "bold",
                borderRadius: "4px",
                minWidth: { xs: "100px", md: "120px" },
                textTransform: "capitalize",
                "&:not(:last-of-type)": {
                  mr: { xs: 1, md: 0.5 },
                },
                "&:hover": {
                  backgroundColor: "#DC3545",
                  color: "white",
                },
              },
              "& button.active-tab": {
                backgroundColor: primaryGreen,
                color: "white",
                border: `1px solid ${primaryGreen}`,
                "&:hover": {
                  backgroundColor: "#DC3545",
                  color: "white",
                },
              },
            }}
          >
            {[
              { id: "active", label: "active" },
              { id: "inactive", label: "inactive" },
              { id: "Pending", label: "approval pending" },
              { id: "Approved", label: "approved" },
              { id: "Reject", label: "rejected" },
            ].map((tab) => (
              <Button
                key={tab.id}
                className={activeTab === tab.id ? "active-tab" : ""}
                onClick={() => handleTabChange(tab.id)}
              >
                {tab.label}
              </Button>
            ))}
          </Box>
        </Box>
        {
          permissions.includes("create_seller") && (
            <Button
              variant="contained"
              sx={{
                backgroundColor: primaryGreen,
                "&:hover": {
                  backgroundColor: "white",
                  border: "2px solid #DC3545",
                  color: "#DC3545",
                },
                color: "white",
                fontWeight: "bold",
                textTransform: "none",
                width: { xs: "100%", md: "auto" },
                mt: { xs: 2, md: 0 },
              }}
              onClick={() => setShowAddSellerModal(true)}
            >
              <i className="bi bi-plus-circle me-2"></i>Add Seller
            </Button>
          )}
      </Box>
      {/* Seller Table */}
      <div className="table-container border rounded">
        <div className="table-responsive">
          {loading && !isModalOpen && !showAddSellerModal ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
              }}
            >
              <CircularProgress style={{ color: primaryGreen }} />
              <Typography sx={{ ml: 2 }}>Loading sellers...</Typography>
            </Box>
          ) : (
            <table className="table text-center m-0 resource-head">
              <thead
                className="sticky-header fs-6"
                style={{ backgroundColor: lightGreen }}
              >
                <tr>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor }}
                  >
                    S.No
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: 'left' }}
                  >
                    Name
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: 'left' }}
                  >
                    Email
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: 'left' }}
                  >
                    Phone
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor }}
                  >
                    Status
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: 'left' }}
                  >
                    Approval Status
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: 'left' }}
                  >
                    Verified
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: 'left' }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((seller, index) => (
                    <tr key={seller._id}>
                      {/* S.No column */}
                      <td style={{ textAlign: "left" }}>{indexOfFirstItem + index + 1}</td>

                      {/* Name column */}
                      <td
                        onClick={() => navigate(`/backoffice/seller-details/${seller._id}`)}
                        style={{
                          fontWeight: "bold",
                          color: primaryGreen,
                          cursor: "pointer",
                          textDecoration: "none",
                          textAlign: "left",
                        }}
                        onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
                        onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
                      >
                        {seller.name}
                      </td>

                      {/* Email column */}
                      <td style={{ textAlign: "left" }}>{seller.email}</td>

                      {/* Phone Number column */}
                      <td style={{ textAlign: "left" }}>{seller.phone_number}</td>

                      {/* Status column - Align the parent td to left, the content inside remains centered due to flexbox */}
                      <td>
                        <div className="form-check form-switch d-flex justify-content-center align-items-center">
                          <Switch
                            checked={seller.status === "Active"}
                            onChange={() => handleStatusToggle(seller._id, seller.status)}
                            sx={{
                              "& .MuiSwitch-switchBase.Mui-checked": {
                                color: primaryGreen,
                                "&:hover": {
                                  backgroundColor: "rgba(0, 178, 7, 0.08)",
                                },
                              },
                              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                backgroundColor: primaryGreen,
                              },
                              "& .MuiSwitch-switchBase:not(.Mui-checked)": {
                                color: "text.secondary",
                              },
                              "& .MuiSwitch-track": {
                                backgroundColor: "rgba(0, 0, 0, 0.38)",
                              },
                            }}
                          />
                          <Chip
                            label={seller.status}
                            size="small"
                            sx={{
                              ml: 1,
                              backgroundColor:
                                seller.status === "Active" ? lightGreen : "#ffe0b2",
                              color: seller.status === "Active" ? "black" : "#ef6c00",
                            }}
                          />
                        </div>
                      </td>

                      {/* Approval Status column */}
                      <td >
                        <Chip
                          label={seller.Approval_status || "Pending"}
                          size="small"
                          color={
                            seller.Approval_status === "Pending"
                              ? "warning"
                              : seller.Approval_status === "Approved"
                                ? "success"
                                : seller.Approval_status === "Reject"
                                  ? "error"
                                  : "default"
                          }
                        />
                      </td>

                      {/* OTP Verify column */}
                      <td style={{ textAlign: "left" }}>{seller.otp_verify ? "Yes" : "No"}</td>

                      {/* Action column - Align the parent td to left, the content inside remains centered due to flexbox */}
                      <td style={{ textAlign: "left" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: { xs: 0.5, md: 1 },
                          }}
                        >
                          {
                            permissions.includes("update_seller") && (
                              <IconButton
                                color="primary"
                                onClick={() => handleEdit(seller)}
                                title="Edit Approval"
                                sx={{
                                  color: primaryGreen,
                                  p: { xs: 0.5, md: 1 },
                                }}
                              >
                                <EditIcon
                                  sx={{
                                    fontSize: { xs: "1.1rem", md: "1.5rem" },
                                  }}
                                />
                              </IconButton>
                            )}
                          <IconButton
                            color="info"
                            onClick={() => navigate(`/backoffice/seller-details/${seller._id}`)}
                            title="View Details"
                            sx={{
                              color: primaryGreen,
                              p: { xs: 0.5, md: 1 },
                            }}
                          >
                            <VisibilityIcon
                              sx={{
                                fontSize: { xs: "1.1rem", md: "1.5rem" },
                              }}
                            />
                          </IconButton>
                        </Box>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          p: 4,
                          textAlign: "center",
                        }}
                      >
                        <PersonIcon
                          sx={{
                            color: secondaryTextColor,
                            fontSize: 60,
                            mb: 1,
                          }}
                        />
                        <Typography variant="h6" sx={{ color: secondaryTextColor }}>
                          No sellers found
                        </Typography>
                      </Box>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {totalPages > 1 && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3, mb: 2 }}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            sx={{
              "& .MuiPaginationItem-root": {
                color: primaryGreen,
              },
              "& .MuiPaginationItem-root.Mui-selected": {
                backgroundColor: primaryGreen,
                color: "white",
                "&:hover": {
                  backgroundColor: "#b02a37",
                },
              },
            }}
          />
        </Box>
      )}

      {/* Approval Status and Seller Details Modal (Material-UI Dialog) */}
      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        noValidate
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{ backgroundColor: primaryGreen, color: "white", p: 0 }}
        >
          <div
            className="modal-header text-white"
            style={{
              backgroundColor: primaryGreen,
              padding: "16px 24px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h5 className="modal-title" style={{ margin: 0 }}>
              Update Seller Details
            </h5>
            <IconButton
              aria-label="close"
              onClick={() => setIsModalOpen(false)}
              sx={{ color: "white" }}
            >
              <i className="bi bi-x-lg"></i>
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          {isModalLoading ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: 200,
              }}
            >
              <CircularProgress style={{ color: primaryGreen }} />
              <Typography sx={{ mt: 2, color: primaryGreen }}>Loading seller details...</Typography>
            </Box>
          ) : (
            currentSeller && (
              <>
                <TextField
                  label={
                    <span>
                      Seller Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  value={currentSeller.name || ""}
                  fullWidth
                  disabled
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label={
                    <span>
                      Email <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  value={currentSeller.email || ""}
                  fullWidth
                  disabled
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label={
                    <span>
                      Phone Number <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  value={currentSeller.phone_number || ""}
                  fullWidth
                  disabled
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label={
                    <span>
                      Serving Location (comma-separated){" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="servingLocation"
                  value={approvalFormData.servingLocation}
                  onChange={handleApprovalInputChange}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  error={!!approvalErrors.servingLocation}
                  helperText={approvalErrors.servingLocation}
                />
                <FormControl
                  fullWidth
                  margin="normal"
                  error={!!approvalErrors.deliveryMethod}
                >
                  {/* <InputLabel id="delivery-method-label">
                    Delivery Method <span style={{ color: "red" }}>*</span>
                  </InputLabel> */}
                  <TextField
                    select
                    labelId="delivery-method-label"
                    label={
                      <span>
                        Delivery Method <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="deliveryMethod"
                    value={approvalFormData.deliveryMethod}
                    onChange={handleApprovalInputChange}
                    fullWidth
                    variant="outlined"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value="Pick up">Pick up</MenuItem>
                    <MenuItem value="Shipping">Shipping</MenuItem>
                    <MenuItem value="Both">Both</MenuItem>
                  </TextField>
                  {approvalErrors.deliveryMethod && (
                    <Typography color="error" variant="caption">
                      {approvalErrors.deliveryMethod}
                    </Typography>
                  )}
                </FormControl>
                <FormControl component="fieldset" margin="normal">
                  <FormLabel component="legend">Approval Status</FormLabel>
                  <RadioGroup
                    row
                    name="approvalStatus"
                    value={approvalStatus}
                    onChange={(e) => setApprovalStatus(e.target.value)}
                  >
                    <FormControlLabel
                      value="Pending"
                      control={
                        <Radio
                          sx={{
                            color: primaryGreen,
                            "&.Mui-checked": { color: primaryGreen },
                          }}
                        />
                      }
                      label="Pending"
                    />
                    <FormControlLabel
                      value="Approval"
                      control={
                        <Radio
                          sx={{
                            color: primaryGreen,
                            "&.Mui-checked": { color: primaryGreen },
                          }}
                        />
                      }
                      label="Approved"
                    />
                    <FormControlLabel
                      value="Reject"
                      control={
                        <Radio
                          sx={{
                            color: primaryGreen,
                            "&.Mui-checked": { color: primaryGreen },
                          }}
                        />
                      }
                      label="Reject"
                    />
                  </RadioGroup>
                </FormControl>
                <Box mt={2}>
                  <input
                    type="file"
                    accept="image/jpeg,image/png,image/gif,application/pdf"
                    name="idProofFile"
                    onChange={handleApprovalInputChange}
                    style={{ display: "none" }}
                    id="id-proof-upload"
                  />
                  <label htmlFor="id-proof-upload">
                    <Button
                      variant="outlined"
                      component="span"
                      disabled={isIdProofUploading}
                      sx={{
                        borderColor: primaryGreen,
                        color: primaryGreen,
                        "&:hover": { borderColor: "#b02a37", color: "#b02a37" },
                      }}
                    >
                      {isIdProofUploading ? (
                        <CircularProgress size={24} />
                      ) : (
                        "Upload ID Proof"
                      )}
                    </Button>
                  </label>
                  {approvalFormData.idProofUrl && (
                    <Box mt={1}>
                      <Typography
                        variant="body2"
                        sx={{ display: "inline-block", mr: 1 }}
                      >
                        Current ID Proof:
                      </Typography>
                      <Button
                        variant="text"
                        onClick={() => {
                          setIdProofToViewUrl(approvalFormData.idProofUrl);
                          setShowIdProofViewer(true);
                        }}
                        sx={{ color: primaryGreen }}
                      >
                        {isImageUrl(approvalFormData.idProofUrl)
                          ? "View Image"
                          : "View PDF"}
                      </Button>
                    </Box>
                  )}
                  {idProofError && (
                    <Typography color="error" variant="caption">
                      {idProofError}
                    </Typography>
                  )}
                  {approvalErrors.idProofFile && (
                    <Typography color="error" variant="caption">
                      {approvalErrors.idProofFile}
                    </Typography>
                  )}
                </Box>
              </>
            )
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setIsModalOpen(false)}
            style={{ color: "#00b207" }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateApproval}
            sx={{
              backgroundColor: primaryGreen,
              color: "white",
              "&:hover": { backgroundColor: "#b02a37" },
            }}
            disabled={loading || isModalLoading}
          >
            {loading ? "Updating..." : "Update"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Seller Modal (Material-UI Dialog) */}
      <Dialog
        open={showAddSellerModal}
        onClose={() => setShowAddSellerModal(false)}
        noValidate
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{ backgroundColor: primaryGreen, color: "white", p: 0 }}
        >
          <div
            className="modal-header text-white"
            style={{
              backgroundColor: primaryGreen,
              padding: "16px 24px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h5 className="modal-title" style={{ margin: 0 }}>
              Add New Seller
            </h5>
            <IconButton
              aria-label="close"
              onClick={() => setShowAddSellerModal(false)}
              sx={{ color: "white" }}
            >
              <i className="bi bi-x-lg"></i>
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            label={
              <span>
                Seller Name
              </span>
            }
            name="name"
            value={newSellerData.name}
            onChange={handleNewSellerInputChange}
            fullWidth
            margin="normal"
            variant="outlined"
            required
            error={!!newSellerErrors.name}
            helperText={newSellerErrors.name}
          />
          <TextField
            label={
              <span>
                Email
              </span>
            }
            name="email"
            type="email"
            value={newSellerData.email}
            onChange={handleNewSellerInputChange}
            fullWidth
            margin="normal"
            variant="outlined"
            required
            error={!!newSellerErrors.email}
            helperText={newSellerErrors.email}
          />
          <TextField
            label={
              <span>
                Phone Number
              </span>
            }
            name="phone_number"
            type="tel"
            value={newSellerData.phone_number}
            onChange={handleNewSellerInputChange}
            fullWidth
            margin="normal"
            variant="outlined"
            required
            error={!!newSellerErrors.phone_number}
            helperText={newSellerErrors.phone_number}
          />
          <TextField
            label={
              <span>
                Password
              </span>
            }
            name="password"
            type="password"
            value={newSellerData.password}
            onChange={handleNewSellerInputChange}
            fullWidth
            margin="normal"
            variant="outlined"
            required
            error={!!newSellerErrors.password}
            helperText={newSellerErrors.password}
          />
          <TextField
            label="Role"
            value={newSellerData.role}
            fullWidth
            disabled
            margin="normal"
            variant="outlined"
            helperText="Role is automatically set to 'seller'"
          />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setShowAddSellerModal(false)}
            style={{ color: "#00b207" }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAddSeller}
            sx={{
              backgroundColor: primaryGreen,
              color: "white",
              "&:hover": { backgroundColor: "#b02a37" },
            }}
            disabled={loading}
          >
            {loading ? "Adding..." : "Add Seller"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ID Proof Viewer Dialog */}
      <Dialog
        open={showIdProofViewer}
        onClose={() => setShowIdProofViewer(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{ backgroundColor: primaryGreen, color: "white", p: 0 }}
        >
          <div
            className="modal-header text-white"
            style={{
              backgroundColor: primaryGreen,
              padding: "16px 24px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h5 className="modal-title" style={{ margin: 0 }}>
              ID Proof
            </h5>
            <IconButton
              aria-label="close"
              onClick={() => setShowIdProofViewer(false)}
              sx={{ color: "white" }}
            >
              <i className="bi bi-x-lg"></i>
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "300px",
          }}
        >
          {idProofToViewUrl ? (
            isImageUrl(idProofToViewUrl) ? (
              <img
                src={idProofToViewUrl}
                alt="ID Proof"
                style={{
                  maxWidth: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
              />
            ) : (
              <iframe
                src={idProofToViewUrl}
                width="100%"
                height="500px"
                style={{ border: "none" }}
                title="ID Proof PDF"
              ></iframe>
            )
          ) : (
            <Typography>No ID proof available.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowIdProofViewer(false)}
            style={{ color: primaryGreen }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default SellerManagement;
